export default __webpack_public_path__ + "static/media/css.d9c2e229.svg";